import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Twitter, Linkedin, Github } from 'lucide-react';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import './Footer.scss';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer__content">
          {/* Company Info */}
          <div className="footer__section">
            <div className="footer__logo">
              <img src="/logo.png" alt="CoinVAT" className="footer__logo-image" />
              <span className="footer__logo-text">
                <span className="gradient-text">CoinVAT</span>
              </span>
            </div>
            <p className="footer__description">
              Revolutionizing cryptocurrency trading with our Virtualized Automatic Trader. 
              Experience the future of intelligent, automated trading solutions.
            </p>
            <div className="footer__contact">
              <div className="footer__contact-item">
                <Mail size={16} />
                <span>contact@coinvat.io</span>
              </div>
              <div className="footer__contact-item">
                <Phone size={16} />
                <span>+1 (420) 429-0188</span>
              </div>
              <div className="footer__contact-item">
                <MapPin size={16} />
                <span>Baltimore, MD</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer__section">
            <h4 className="footer__title">Quick Links</h4>
            <ul className="footer__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Product */}
          <div className="footer__section">
            <h4 className="footer__title">Product</h4>
            <ul className="footer__links">
              <li><Link to="/trading">Trading Platform</Link></li>
              <li><Link to="/api-docs">API Documentation</Link></li>
              <li><Link to="/security">Security</Link></li>
              <li><Link to="/performance">Performance</Link></li>
              <li><Link to="/integrations">Integrations</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer__section">
            <h4 className="footer__title">Support</h4>
            <ul className="footer__links">
              <li><Link to="/help">Help Center</Link></li>
              <li><Link to="/docs">Documentation</Link></li>
              <li><Link to="/status">System Status</Link></li>
              <li><Link to="/community">Community</Link></li>
              <li><Link to="/support">Contact Support</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer__section">
            <h4 className="footer__title">Legal</h4>
            <ul className="footer__links">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/compliance">Compliance</Link></li>
              <li><Link to="/cookies">Cookie Policy</Link></li>
              <li><Link to="/licenses">Licenses</Link></li>
            </ul>
          </div>
        </div>

        {/* Social Links & Newsletter */}
        <div className="footer__newsletter">
          <div className="footer__newsletter-content">
            <h4 className="footer__newsletter-title">Stay Updated</h4>
            <p className="footer__newsletter-text">
              Get the latest updates on trading features and market insights.
            </p>
          </div>
          <div className="footer__newsletter-form">
            <div className="footer__email-input">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="footer__email-field"
              />
              <button className="btn btn-primary">Subscribe</button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-content">
            <div className="footer__copyright">
              <p>&copy; {currentYear} CoinVAT LLC. All rights reserved.</p>
              <p className="footer__tagline">AI Trading Bot + AI-Assisted Trading Platform</p>
            </div>
            
            <div className="footer__actions">
              <ThemeToggle />
              <div className="footer__social">
                <a href="https://twitter.com/coinvatllc" target="_blank" rel="noopener noreferrer" className="footer__social-link">
                  <Twitter size={20} />
                </a>
                <a href="https://linkedin.com/company/coinvat" target="_blank" rel="noopener noreferrer" className="footer__social-link">
                  <Linkedin size={20} />
                </a>
                <a href="https://github.com/coinvat" target="_blank" rel="noopener noreferrer" className="footer__social-link">
                  <Github size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
